import _ from 'lodash';

export function contestsDetailReducer(state = {
    data: null,
    assets: null,
    isSubmitLoading: false,
    isSubmitSuccess: false
  }, action){
    switch(action.type){
      case 'GET_CONTEST_DETAIL_FULFILLED':
        return Object.assign({}, state, {
          data: action.payload.data.results
        })
      case 'GET_CONTEST_DETAIL_PENDING':
        return Object.assign({}, state, {
            data: null
        })
      case 'GET_ASSETS_FULFILLED':
        return Object.assign({}, state, {
            assets: action.payload.data.results.data
        })
      case 'SUBMIT_ASSETS_PENDING': 
        return Object.assign({}, state, {
            isSubmitLoading: true,
            isSubmitSuccess: false
        })
      case 'SUBMIT_ASSETS_FULFILLED':
        return Object.assign({}, state, {
            isSubmitLoading: false,
            isSubmitSuccess: true,
        })
      default:
        return state
    }
  }

export function contestReducer(state = {
    data: [],
    links: null,
    isPending: true,
    isRejected: false,
}, action){
    switch(action.type){
        case 'GET_CONTEST_REJECTED':
          return Object.assign({}, state, {
            // data: state.data,
            isPending: false,
            isRejected: true,
          })      
        case 'GET_CONTEST_PENDING':
            return Object.assign({}, state, {
                // data: state.data,
                isPending: true,
                isRejected: true,
            })      
        case 'GET_CONTEST_FULFILLED':
            console.log(state.data, 'check data')
            return Object.assign({}, state, {
                data:  action.payload.data.results.meta.current_page === 1 ?
                        action.payload.data.results.data : 
                        state.data.concat(action.payload.data.results.data),
                links: action.payload.data.results.links,
                isPending: false,
                isRejected: true
            })
        default:
            return state
    }
}

export function getGifts(state ={
  data: {},
  isPending: true,
  isRejected: false,
}, action){
  switch(action.type){
    case "GET_GIFTS_FULFILLED":
      return Object.assign({}, state, {
        data: action.payload.data.results,
        isPending: false,
      })
    case "GET_GIFTS_PENDING":
        return Object.assign({}, state, {
          data: {},
          isPending: true,
          isRejected: false,
        })      
    default: 
      return state
  }
}

export function getEntries(state ={
  data: [],
  isPending: true,
  isRejected: false,
  total: 0,
  contest_status: false,
}, action){
  switch(action.type){
    case "GET_ENTRIES_FULFILLED":
      return Object.assign({}, state, {
        data:  action.payload.data.results.meta.current_page === 1 ?
                action.payload.data.results.data : 
                state.data.concat(action.payload.data.results.data),
        links: action.payload.data.results.links,
        total: action.payload.data.results.total,
        isPending: false,
        contest_status: action.payload.data.results.contest_status,
        isRejected: true
      })
    case "GET_ENTRIES_PENDING":
        return Object.assign({}, state, {
          isPending: true,
          isRejected: false,
          contest_status: false,
        })
    case "GET_ENTRIES_RESET":
      return Object.assign({}, state, {
        data: [],
        isPending: true,
        isRejected: false,
        contest_status: false,
      })               
    default: 
      return state
  }
}




export function getWinners(state ={
  data: [],
  isPending: true,
  isRejected: false,
}, action){
  switch(action.type){
    case "GET_WINNERS_FULFILLED":
      return Object.assign({}, state, {
        data: action.payload.data.results.data,
        isPending: false,
      })
    case "GET_WINNERS_PENDING":
        return Object.assign({}, state, {
          data: [],
          isPending: true,
          isRejected: false,
        })      
    default: 
      return state
  }
}


export function joinContest(state ={
  isPending: false,
  isRejected: false,
  isSubmitSuccess: false,
}, action){
  switch(action.type){
    case "JOIN_CONTEST_FULFILLED":
      return Object.assign({}, state, {
        isPending: false,
        isRejected: false,
        isSubmitSuccess: true,
      })
    case "JOIN_CONTEST_PENDING":
        return Object.assign({}, state, {
          isPending: true,
          isRejected: false,
        })      
    default: 
      return state
  }
}

export function discussContest(state ={
  data: [],
  isPending: true,
  isRejected: false,
  contest_status: false,
}, action){
  switch(action.type){
    case "GET_CONTEST_COMMENTS_FULFILLED":
      return Object.assign({}, state, {
        data:  action.payload.data.results.meta.current_page === 1 ?
                action.payload.data.results.data : 
                state.data.concat(action.payload.data.results.data),
        links: action.payload.data.results.links,
        isPending: false,
        contest_status: action.payload.data.results.contest_status,
        isRejected: true
      })
    case "GET_CONTEST_COMMENTS_PENDING":
        return Object.assign({}, state, {
          isPending: true,
          isRejected: false,
          contest_status: false,
        })
    case "GET_CONTEST_COMMENTS_RESET":
      return Object.assign({}, state, {
        data: [],
        isPending: true,
        isRejected: false,
        contest_status: false,
      })               
    default: 
      return state
  }
}

export function addComments(state ={
  isPending: false,
  isRejected: false,
  isSubmitSuccess: false,
}, action){
  switch(action.type){
    case "ADD_CONTEST_COMMENTS_FULFILLED":
      return Object.assign({}, state, {
        isPending: false,
        isRejected: false,
        isSubmitSuccess: true,
      })
    case "ADD_CONTEST_COMMENTS_PENDING":
        return Object.assign({}, state, {
          isPending: true,
          isRejected: false,
        })      
    default: 
      return state
  }
}
